import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center py-4" }
const _hoisted_2 = { class: "border rounded-md" }
const _hoisted_3 = { class: "flex items-center justify-end py-4 space-x-2" }

import { Plus } from 'lucide-vue-next'
  import {
    ColumnDef,
    FlexRender,
    getCoreRowModel, getFilteredRowModel, getPaginationRowModel,
    useVueTable,
  } from '@tanstack/vue-table'
  import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
  } from '@/components/ui/table'
  import { Button } from "@/components/ui/button";
  import { ref } from "vue";
  import { valueUpdater } from '@/utils/utils'
  import { Input } from "@/components/ui/input";
  import useEventsBus from "@/utils/eventBus";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    columns: {},
    data: {},
    entity: {}
  },
  setup(__props: any) {

  const props = __props

  const globalFilter = ref('');
  const setGlobalFilter = (value: string) => {
    globalFilter.value = value;
  };
  const { emit } = useEventsBus();

  const table = useVueTable({
    get data() { return props.data },
    get columns() { return props.columns },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onGlobalFilterChange: updaterOrValue => valueUpdater(updaterOrValue, globalFilter),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      get globalFilter() { return globalFilter.value },
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Input), {
        class: "max-w-sm",
        placeholder: _ctx.$t('table.search'),
        "model-value": globalFilter.value || '',
        "onUpdate:modelValue": _cache[0] || (_cache[0] = value => setGlobalFilter(String(value)))
      }, null, 8, ["placeholder", "model-value"]),
      _createVNode(_unref(Button), {
        class: "ml-auto",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(emit)('new_'+props.entity, {})))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Plus), { class: "mr-2 h-5 w-5" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('table.add')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Table), null, {
        default: _withCtx(() => [
          _createVNode(_unref(TableHeader), { class: "bg-gray-300 font-black" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(table).getHeaderGroups(), (headerGroup) => {
                return (_openBlock(), _createBlock(_unref(TableRow), {
                  key: headerGroup.id
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerGroup.headers, (header) => {
                      return (_openBlock(), _createBlock(_unref(TableHead), {
                        key: header.id
                      }, {
                        default: _withCtx(() => [
                          (!header.isPlaceholder)
                            ? (_openBlock(), _createBlock(_unref(FlexRender), {
                                key: 0,
                                render: header.column.columnDef.header,
                                props: header.getContext()
                              }, null, 8, ["render", "props"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_unref(TableBody), null, {
            default: _withCtx(() => [
              (_unref(table).getRowModel().rows?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(table).getRowModel().rows, (row) => {
                    return (_openBlock(), _createBlock(_unref(TableRow), {
                      key: row.id,
                      "data-state": row.getIsSelected() ? 'selected' : undefined
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.getVisibleCells(), (cell) => {
                          return (_openBlock(), _createBlock(_unref(TableCell), {
                            key: cell.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FlexRender), {
                                render: cell.column.columnDef.cell,
                                props: cell.getContext()
                              }, null, 8, ["render", "props"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["data-state"]))
                  }), 128))
                : (_openBlock(), _createBlock(_unref(TableRow), { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TableCell), {
                        colSpan: _ctx.columns.length,
                        class: "h-24 text-center"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                        ]),
                        _: 1
                      }, 8, ["colSpan"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Button), {
        variant: "outline",
        size: "sm",
        disabled: !_unref(table).getCanPreviousPage(),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(table).previousPage()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('table.previous')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(Button), {
        variant: "outline",
        size: "sm",
        disabled: !_unref(table).getCanNextPage(),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(table).nextPage()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('table.next')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})